import { Button, Modal, Notifications, Progress } from "d-react-components";
import { useFormik } from "formik";
import React, { useContext, useMemo, useState } from "react";
import OrderAPI from "../../api/order/OrderAPI";
import InputTextForm from "../../components/InputTextForm";
import { ORDER_STATUS } from "../../constant/order";
import { AppStateContext } from "../../context/app";
import { mapOrderContactToServer } from "../../interface/order";
import Messages from "../../languages/Messages";
import { OrderContactSchema } from "../../schema/order";
import SectionHeader from "../../components/SectionHeader";

interface IOrderContactUpdateModal {
    open: boolean;
    onClose: () => void;
}

const OrderContactUpdateModal = ({
    open,
    onClose,
}: IOrderContactUpdateModal) => {
    const { orderDetail, setOrderDetail } = useContext(AppStateContext);
    const { orderContact } = orderDetail ?? {};

    const contactValueDefault = {
        ...(orderContact ?? {}),
        confirmEmail: orderContact?.email,
        confirmPhone: orderContact?.phone,
    };

    const validateContact = (values: any) => {
        const { confirmEmail, email, confirmPhone, phone } = values;
        const errors = {} as any;
        if (confirmEmail !== email) {
            errors.confirmEmail = Messages.emailNotMatch;
        }
        if (confirmPhone !== phone) {
            errors.confirmPhone = Messages.phoneNotMatch;
        }

        return errors;
    };

    const contactForm = useFormik<any>({
        initialValues: contactValueDefault as any,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: OrderContactSchema,
        validate: validateContact,
        onSubmit: (values: any) => {
            const input = mapOrderContactToServer(values);
            onUpdateContact(input);
        },
    });

    const onUpdateContact = (input: any) => {
        Progress.show(
            {
                method: OrderAPI.updateContact,
                params: [orderDetail?.id, input],
            },
            (orderRes: any) => {
                onClose();
                setOrderDetail(orderRes);
                Notifications.showSuccess(Messages.updateOrderContactSuccess);
            }
        );
    };

    const classNameInput = "col-12 col-sm-6 mt-3";

    const renderInput = (keyData: string) => (
        <InputTextForm
            form={contactForm}
            className={classNameInput}
            keyData={keyData}
        />
    );
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={Messages.updateContact}
            onSave={() => contactForm.handleSubmit()}
        >
            <div className="row">
                {renderInput("firstName")}
                {renderInput("lastName")}
                {renderInput("email")}
                {renderInput("confirmEmail")}
                {renderInput("phone")}
                {renderInput("confirmPhone")}
            </div>
        </Modal>
    );
};

const OrderContact = () => {
    const { orderDetail } = useContext(AppStateContext);
    const { status, orderContact } = orderDetail ?? {};
    const [openEdit, setOpenEdit] = useState(false);

    const isHideEdit = useMemo(
        () =>
            status !== ORDER_STATUS.PENDING_PAYMENT &&
            status !== ORDER_STATUS.PENDING_CONFIRMATION,
        [status]
    );

    return (
        <div className="card-container p-4 mt-3">
            <SectionHeader
                label={Messages.orderContact}
                hiddenEdit={isHideEdit}
                onClickEdit={() => setOpenEdit(true)}
            />
            <small>{Messages.orderContactDesc}</small>
            <div className="mt-3 flex-column">
                <text>{`${orderContact?.firstName} ${orderContact?.lastName}`}</text>
                <text>{orderContact?.phone}</text>
                <text>{orderContact?.email}</text>
            </div>
            {openEdit && (
                <OrderContactUpdateModal
                    open={openEdit}
                    onClose={() => setOpenEdit(false)}
                />
            )}
        </div>
    );
};

export default OrderContact;
